var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.16667C12.5 4.82971 12.7634 5.4656 13.2322 5.93444C13.7011 6.40328 14.337 6.66667 15 6.66667C15.663 6.66667 16.2989 6.40328 16.7678 5.93444C17.2366 5.4656 17.5 4.82971 17.5 4.16667C17.5 3.50363 17.2366 2.86775 16.7678 2.3989C16.2989 1.93006 15.663 1.66667 15 1.66667C14.337 1.66667 13.7011 1.93006 13.2322 2.3989C12.7634 2.86775 12.5 3.50363 12.5 4.16667Z",
    stroke: "#2E80DB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.5 10.663 2.76339 11.2989 3.23223 11.7678C3.70107 12.2366 4.33696 12.5 5 12.5C5.66304 12.5 6.29893 12.2366 6.76777 11.7678C7.23661 11.2989 7.5 10.663 7.5 10C7.5 9.33696 7.23661 8.70107 6.76777 8.23223C6.29893 7.76339 5.66304 7.5 5 7.5C4.33696 7.5 3.70107 7.76339 3.23223 8.23223C2.76339 8.70107 2.5 9.33696 2.5 10Z",
    stroke: "#2E80DB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.8333C12.5 16.4964 12.7634 17.1323 13.2322 17.6011C13.7011 18.0699 14.337 18.3333 15 18.3333C15.663 18.3333 16.2989 18.0699 16.7678 17.6011C17.2366 17.1323 17.5 16.4964 17.5 15.8333C17.5 15.1703 17.2366 14.5344 16.7678 14.0656C16.2989 13.5967 15.663 13.3333 15 13.3333C14.337 13.3333 13.7011 13.5967 13.2322 14.0656C12.7634 14.5344 12.5 15.1703 12.5 15.8333Z",
    stroke: "#2E80DB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15625 11.2583L12.8479 14.575",
    stroke: "#2E80DB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8396 5.42499L7.15625 8.74165",
    stroke: "#2E80DB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcons);
export default __webpack_public_path__ + "static/media/share-icons.456af8ed789c029aa262fd3aa8bd8a71.svg";
export { ForwardRef as ReactComponent };